function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.regexp.exec.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { observer } from "mobx-react";
import PropTypes from "prop-types";
import { Component } from "react";
import { withTranslation } from "react-i18next";
import { withTheme } from "styled-components";
import Spacing from "../../../../Styled/Spacing";
import Text from "../../../../Styled/Text";
import Box from "../../../../Styled/Box";
import styled from "styled-components";
import { applyTranslationIfExists } from "../../../../Language/languageHelpers";
import { parseCustomMarkdownToReactWithOptions } from "../../../Custom/parseCustomMarkdownToReact";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const Numbers = styled(Text).withConfig({
  displayName: "StyledHtml__Numbers",
  componentId: "sc-1fnh2dx-0"
})(["width:22px;height:22px;line-height:22px;border-radius:50%;background-color:", ";"], props => props.theme.textDarker);
const renderOrderedList = function (contents) {
  return contents.map((content, i) => /*#__PURE__*/_jsxs(Box, {
    paddedVertically: true,
    children: [/*#__PURE__*/_jsxs(Box, {
      alignItemsFlexStart: true,
      children: [/*#__PURE__*/_jsx(Numbers, {
        textLight: true,
        textAlignCenter: true,
        darkBg: true,
        children: i + 1
      }), /*#__PURE__*/_jsx(Spacing, {
        right: 3
      })]
    }), /*#__PURE__*/_jsx(Text, {
      medium: true,
      textDark: true,
      children: content
    })]
  }, i));
};
export class StyledHtmlRaw extends Component {
  render() {
    const {
      viewState,
      injectTooltips,
      i18n
    } = this.props;
    const styledTextProps = this.props.styledTextProps || {};
    const markdownToParse = applyTranslationIfExists(this.props.markdown, i18n);
    const parsed = parseCustomMarkdownToReactWithOptions(markdownToParse, {
      injectTermsAsTooltips: injectTooltips,
      tooltipTerms: viewState.terria.configParameters.helpContentTerms
    });
    const content = Array.isArray(parsed.props.children) ? parsed.props.children : [parsed.props.children];
    return /*#__PURE__*/_jsx("div", {
      children: (content === null || content === void 0 ? void 0 : content.map) && content.map((item, i) => {
        if (!item) return null;

        /* Either a header or paragraph tag */
        if (/(h[0-6]|p)/i.test(item.type)) {
          return /*#__PURE__*/_jsx(Text, _objectSpread(_objectSpread({
            as: item.type,
            textDark: true,
            medium: item.type === "p"
          }, styledTextProps), {}, {
            children: item.props.children
          }), i);
        } else if (item.type === "ol") {
          return /*#__PURE__*/_jsxs(_Fragment, {
            children: [renderOrderedList(item.props.children.map(point => point.props.children)), /*#__PURE__*/_jsx(Spacing, {
              bottom: 4
            })]
          });
          /* If it's none of the above tags, just render as
              normal html but with the same text formatting.
              We can style more tags as necessary */
        } else {
          return /*#__PURE__*/_jsx(Text, _objectSpread(_objectSpread({
            textDark: true,
            medium: true
          }, styledTextProps), {}, {
            children: item
          }), i);
        }
      })
    });
  }
}
_defineProperty(StyledHtmlRaw, "displayName", "StyledHtml");
_defineProperty(StyledHtmlRaw, "propTypes", {
  markdown: PropTypes.string.isRequired,
  viewState: PropTypes.object.isRequired,
  theme: PropTypes.object,
  styledTextProps: PropTypes.object,
  injectTooltips: PropTypes.bool,
  t: PropTypes.func.isRequired,
  i18n: PropTypes.object.isRequired
});
_defineProperty(StyledHtmlRaw, "defaultProps", {
  injectTooltips: true
});
export default withTranslation()(withTheme(observer(StyledHtmlRaw)));